import {
    Button,
    DivTooltip,
    LineClamp,
    Message,
    StepCSSTransitionGroup,
    Tooltip,
    TooltipBody,
    TooltipFooter,
    TooltipHeader
} from '@wg/wows-react-uikit'

import classNames from 'classnames'
import { t, x } from 'helpers/localization'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import dwhExport from '~/dwhExport'
import { Interpolate } from 'react-i18next'
import settings from 'settings'
import { PURPOSES } from '../../../Actions/ActionRecommendations'
import Card from '../Card/Card'
import { Flags } from '../Flag/Flag'
import styles from './ClanCard.scss'

type RecommendationsPurpose = any

export type IProps = {
    cssLevel: number,
    purpose: RecommendationsPurpose,
    clanId: number,
    tag: String,
    onClanSelect: (clanId: number) => void,
    isClanSelectingEnabled: Boolean,
    errorMessage: any,
    name: String,
    color: String,
    description: String,
    languages: Array<String>,
    memberCount: number,
    isVoiceRequired: Boolean,
    similarity: number,
    root: String,
}

class ClanCard extends PureComponent<IProps, any> {

    constructor(props) {
        super(props)

        this.state = {
            isActive: false,
        }

        this.onMouseMove = this.onMouseMove.bind(this)
        this.onMouseEnter = this.onMouseEnter.bind(this)
        this.onMouseLeave = this.onMouseLeave.bind(this)

        this.onClanSelect = this.onClanSelect.bind(this)

        this.openClanBase = this.openClanBase.bind(this)
    }

    componentDidMount() {
        this._isMounted = true
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    onMouseMove() {
        this.focus()
        return true
    }

    onMouseEnter() {
        this.focus()
        return true
    }

    onMouseLeave() {
        this.blur()
        return true
    }

    focus() {
        if (this._isMounted) {
            this.setState({ ...this.state, isActive: true })
        }
    }

    blur() {
        if (this._isMounted) {
            this.setState({ ...this.state, isActive: false })
        }
    }

    onClanSelect(event) {
        this.props.onClanSelect(this.props.clanId)
    }

    openClanBase(event) {
        dwhExport.send(`clanrec.${this.props.purpose}.open_clan`)
        const middleButtonClicked = event.button === 1
        const isInGame = window.navigator.userAgent.indexOf(settings.ingameUserAgent) !== -1
        const url = `${this.props.root}clan-profile/${this.props.clanId}?source=clanrec&purpose=${this.props.purpose}`
        if (!isInGame && middleButtonClicked)
            window.open(url, '_blank')
        else
            this.context.router.push(url)
    }

    render() {
        const tooltipFooter = (
            <TooltipFooter mouseIcon="left">
                {t('Перейти к клановой базе')}
            </TooltipFooter>
        )

        const voiceIcon = this.props.isVoiceRequired ? (
            <div key={-1} className={styles.voiceIconWrapper}>
                <DivTooltip tooltipBody={<TooltipBody>{t('Обязательна голосовая связь')}</TooltipBody>}>
                    <div className={styles.voiceIcon} />
                </DivTooltip>
            </div>
        ) : null

        const isHighSimilarity = this.props.similarity >= 90
        const isLowSimilarity = this.props.similarity < 75

        const fullDescription = this.props.description.replace(/\n/g, '<br />')
        const similaritySpan = (
            <span
                className={
                    classNames(
                        styles.similarity,
                        {
                            [styles.highSimilarity]: isHighSimilarity,
                            [styles.lowSimilarity]: isLowSimilarity,
                        }
                    )}>{this.props.similarity}%</span>
        )
        const clanNameSpan = [
            <span key="clan_name_tag" style={{ color: this.props.color }}>[{this.props.tag}]&nbsp;</span>,
            <span key="clan_name_title" dangerouslySetInnerHTML={{ __html: this.props.name }} />,
        ]

        let clanSimilarityTooltip = x('Клан %(clanName)s не лучший вариант. Рекомендуем изменить условия поиска.')
        if (this.props.similarity >= 50) clanSimilarityTooltip = x('Клан %(clanName)s не очень подходит.')
        if (this.props.similarity >= 60) clanSimilarityTooltip = x('Клан %(clanName)s подходит.')
        if (this.props.similarity >= 70) clanSimilarityTooltip = x('Клан %(clanName)s будет очень хорошим выбором.')
        if (this.props.similarity >= 80) clanSimilarityTooltip = x('Клан %(clanName)s отлично подходит.')
        if (this.props.similarity >= 90) clanSimilarityTooltip = x('Клан %(clanName)s идеально подходит.')

        let buttonSubmit = (
            <Button
                onClick={this.onClanSelect}
                isLarger
                isJustified >
                {t('Отправить заявку:clanrec')}
            </Button>
        )
        if (!this.props.isClanSelectingEnabled)
            buttonSubmit = (
                <DivTooltip tooltipBody={
                    <TooltipBody>
                        <span className={styles.warning}>
                            <Message type="error" style="fullsize">{this.props.errorMessage}</Message>
                        </span>
                    </TooltipBody>
                }>
                    <Button
                        onClick={() => { }}
                        isLarger
                        isJustified
                        isDisabled>
                        {t('Отправить заявку:clanrec')}
                    </Button>
                </DivTooltip>
            )
        let communication = (
            <div className={styles.parameterGroup}>
                <span>{t('Общение')}</span>
                <span className={styles.parameterLanguage}>
                    {voiceIcon}
                    <Flags languages={this.props.languages} maxDisplayCount={3} floating="right" />
                </span>
            </div>
        )
        if (this.props.purpose === PURPOSES.NO_OBLIGATIONS)
            communication = null

        return (
            <StepCSSTransitionGroup level={this.props.cssLevel} className={styles.CSSTransitionGroup}>
                <Card
                    onMouseMove={this.onMouseMove}
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                    className={classNames(styles.wrapper, { [styles.activeWrapper]: this.state.isActive })}>
                    <DivTooltip tooltipBody={
                        <Tooltip>
                            <TooltipHeader>
                                <strong>{clanNameSpan}</strong>
                            </TooltipHeader>
                            <TooltipBody>
                                <LineClamp lines={13}>
                                    <span dangerouslySetInnerHTML={{ __html: fullDescription }} />
                                </LineClamp>
                            </TooltipBody>
                            {tooltipFooter}
                        </Tooltip>
                    }>
                        <div
                            onMouseDown={this.openClanBase}
                            className={classNames(styles.header, { [styles.activeHeader]: this.state.isActive })}>
                            <div className={styles.title}>
                                <LineClamp lines={2}>{clanNameSpan}</LineClamp>
                            </div>
                            <span className={styles.description}>
                                <LineClamp lines={2}>{this.props.description}</LineClamp>
                            </span>
                        </div>
                    </DivTooltip>
                    <DivTooltip tooltipBody={
                        <TooltipBody>
                            <Interpolate
                                i18nKey={clanSimilarityTooltip}
                                clanName={<strong>{clanNameSpan}</strong>}
                                t={t} />
                        </TooltipBody>
                    }>
                        <div className={
                            classNames(
                                styles.parameterGroup, { [styles.parameterGroupHighSimilarity]: isHighSimilarity }
                            )}>
                            <span>{t('Клан подходит вам на')}</span>
                            <span className={styles.parameterSimilarity}>{similaritySpan}</span>
                        </div>
                    </DivTooltip>
                    <div className={styles.parameterGroup}>
                        <span>{t('Количество игроков')}</span>
                        <span className={styles.parameterPlayerCount}>{this.props.memberCount}</span>
                    </div>
                    {communication}
                    <div
                        style={{ display: this.state.isActive ? 'block' : 'none' }} className={styles.submit} >
                        {buttonSubmit}
                    </div>
                </Card>
            </StepCSSTransitionGroup>
        )
    }
}

ClanCard.contextTypes = {
    router: PropTypes.object.isRequired,
}

ClanCard.defaultProps = {
    cssLevel: 1,
    clanId: 0,
    tag: '',
    onClanSelect: (clanId: number) => { },
    isClanSelectingEnabled: true,
    name: '',
    color: '',
    description: '',
    memberCount: 1,
    languages: [],
    isVoiceRequired: false,
    similarity: 90,
    router: {},
    root: '',
}

export default ClanCard